import request from '@/api/fetcher/request'

export function getCouponConfig (data) {
  return request.post('/api/sdk/coupon/config', data)
}

export function reportShowCoupon (data) {
  return request.post('/api/sdk/coupon/report', data)
}
